import React, { useEffect, useRef, useState } from 'react';
import ScrollBar from './ScrollBar';
const ScrollableContent = ({
    relativeX,
    children,
    style,
    completeHideFull,
    ...props
}) => {
    const scrollArea = useRef(null);
    const scrollContent = useRef(null);

    const [currentHeight, setCurrentHeight] = useState(100);
    const [currentScrollHeight, setCurrentScrollHeight] = useState(100);

    const reportWindowSize = () => {
        setCurrentHeight(scrollArea?.current?.clientHeight);
        setCurrentScrollHeight(scrollContent?.current?.clientHeight);
    };

    useEffect(() => {
        window.addEventListener('resize', reportWindowSize);
        setCurrentHeight(scrollArea?.current?.clientHeight);
        setCurrentScrollHeight(scrollContent?.current?.clientHeight);
        document.addEventListener('wheel', doWheel, { passive: false });
        return () => {
            window.removeEventListener('resize', reportWindowSize);
            document.removeEventListener('wheel', doWheel, { passive: false });
        };
    }, []);
    useEffect(() => {
        setCurrentHeight(scrollArea?.current?.clientHeight);
        setCurrentScrollHeight(scrollContent?.current?.clientHeight);
    }, [scrollArea?.current, scrollContent?.current, children]);

    const doWheel = (e) => {
        const p = e.target.closest('.scrollable');

        if (p) {
            // setWheelCount(Math.random());
            e.stopPropagation();
            e.preventDefault();

            if (scrollContent?.current) {
                let current = parseInt(scrollContent.current.style.top);
                current = current + e.deltaY / -10;
                const contheight = parseInt(scrollArea.current.style.height);
                const scheight =
                    scrollContent.current.getBoundingClientRect().height;

                if (contheight - current > scheight) {
                    current = (scheight - contheight) * -1;
                }
                if (current > 0) current = 0;

                scrollContent.current.style.top = current + 'px';
                moveScrollBar();
            }

            return true;
        }
    };

    const moveScrollBar = () => {
        const scrollBar = scrollArea.current.querySelector('.scrollbar');
        const scrollContainer =
            scrollArea.current.querySelector('.scrollcontainer');

        const containerRect = scrollContainer.getBoundingClientRect();
        const contentRect = scrollContent.current.getBoundingClientRect();

        const scrollpct =
            ((contentRect.top - containerRect.top) / -contentRect.height) * 100;

        if (scrollBar) {
            scrollBar.style.top = scrollpct + '%';
        }
    };

    return (
        <>
            <div
                id='something'
                className='scrollable'
                ref={scrollArea}
                style={{
                    // ...style,
                    overflow: 'hidden',
                    backgroundColor: 'white',
                    height: style?.height,
                    flexJustify: 'space-between',
                    padding: 0,
                    display: 'flex',
                    width: '100%'
                }}
            >
                <div style={{ width: '100%' }}>
                    <div
                        ref={scrollContent}
                        style={{
                            position: 'relative',
                            top: 0,
                            width: '100%',
                            verticalAlign: 'top'
                        }}
                    >
                        {children}
                    </div>
                </div>

                <ScrollBar
                    scrollContent={scrollContent}
                    scrollArea={scrollArea}
                    scrollHeight={currentHeight}
                    contentHeight={currentScrollHeight}
                    relativeX={relativeX}
                    completeHideFull={completeHideFull}
                ></ScrollBar>
            </div>
        </>
    );
};

export default ScrollableContent;
